import { makeStyles } from '@material-ui/core';
import { Fragment } from 'react';
import CheckIcon from '@material-ui/icons/Check';
import cx from 'classnames';

const useStyles = makeStyles((theme) => ({
  stepperContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(1, 0),
    width: 'auto',
    minWidth: 200,
  },
  stepWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
    width: 105,
  },
  stepCircle: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: 11,
    transition: 'all 0.3s ease',
    border: '2px solid',
  },
  stepInactive: {
    backgroundColor: '#f8f9fa',
    borderColor: '#e2e8f0',
    color: '#a0aec0',
  },
  stepActive: {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    color: 'white',
    boxShadow: `0 0 0 2px ${theme.palette.primary.main}20`,
  },
  stepCompleted: {
    backgroundColor: '#41C377',
    borderColor: '#41C377',
    color: 'white',
  },
  stepLabel: {
    fontSize: 10,
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    transition: 'color 0.3s ease',
    whiteSpace: 'nowrap',
  },
  stepLabelInactive: {
    color: '#a0aec0',
  },
  stepLabelActive: {
    color: theme.palette.primary.main,
  },
  stepLabelCompleted: {
    color: '#41C377',
  },
  connector: {
    width: 40,
    height: 1,
    transition: 'background-color 0.3s ease',
    marginTop: -10,
  },
  connectorInactive: {
    backgroundColor: '#e2e8f0',
  },
  connectorActive: {
    backgroundColor: theme.palette.primary.main,
  },
  connectorCompleted: {
    backgroundColor: '#41C377',
  },
}));

const CreateUserStepIndicator = ({ currentStep, totalSteps, stepsData }) => {
  const classes = useStyles();


  // Use provided stepsData or fallback to default
  const steps = stepsData || [
    { label: 'CHECK EMAIL', step: 1 },
    { label: 'USER DETAILS', step: 2 },
    { label: 'SELECT ACCOUNTS', step: 3 },
    { label: 'ACCOUNT SETTINGS', step: 4 },
  ];

  const getStepStatus = (stepValue) => {
    if (currentStep > stepValue) return 'completed';
    if (currentStep === stepValue) return 'active';
    return 'inactive';
  };

  const getConnectorStatus = (stepIndex) => {
    const nextStep = stepIndex + 2;
    if (currentStep >= nextStep) return 'completed';
    if (currentStep === stepIndex + 1) return 'active';
    return 'inactive';
  };

  return (
    <div className={classes.stepperContainer}>
      {steps.map((stepData, index) => {
        const status = getStepStatus(stepData.step);
        const isLast = index === steps.length - 1;

        return (
          <Fragment key={stepData.label}>
            <div className={classes.stepWrapper}>
              <div
                className={cx(classes.stepCircle, {
                  [classes.stepInactive]: status === 'inactive',
                  [classes.stepActive]: status === 'active',
                  [classes.stepCompleted]: status === 'completed',
                })}
              >
                {status === 'completed' ? (
                  <CheckIcon style={{ fontSize: 14 }} />
                ) : (
                  stepData.step
                )}
              </div>
              <div
                className={cx(classes.stepLabel, {
                  [classes.stepLabelInactive]: status === 'inactive',
                  [classes.stepLabelActive]: status === 'active',
                  [classes.stepLabelCompleted]: status === 'completed',
                })}
              >
                {stepData.label}
              </div>
            </div>

            {!isLast && (
              <div
                className={cx(classes.connector, {
                  [classes.connectorInactive]: getConnectorStatus(index) === 'inactive',
                  [classes.connectorActive]: getConnectorStatus(index) === 'active',
                  [classes.connectorCompleted]: getConnectorStatus(index) === 'completed',
                })}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default CreateUserStepIndicator;
